// Vendor
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
// Helpers
import Ncookies from 'helpers/ncookies';
// Components
import AppLink from 'components/AppLink';
import Button from 'components/Button';
import Onboarding from 'components/Onboarding';
// Root Styles
import '../../styles/document.styl';
// Styles
import './style.styl';

const cookies = new Ncookies();
class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMobileMenu: false,
      showOnboarding: false,
    };
  }

  componentDidMount = () => {
    const { router } = this.props;
    const { route } = router;
    const hash = window.location.hash;
    if (
      route === '/' ||
      hash === 'onboarding' ||
      hash === 'onboarding-find' ||
      hash === 'onboarding-chare'
    ) {
      // При первом визите пользователя на страницу с лентой показываем онбординг
      const isOnboardingShowed = cookies.get('isOnboardingShowed');
      if (!isOnboardingShowed) {
        this.openOnboarding();
      }
    }
    if (hash === '#onboarding' || hash === '#onboarding-find' || hash === '#onboarding-share') {
      // При наличии нужного хеша в url показываем онбординг
      this.setState({
        onboardingTab: hash,
      });
      this.openOnboarding();
    }
  };

  openMobileMenu = () => {
    this.setState({
      showMobileMenu: true,
    });
  };
  closeMobileMenu = () => {
    this.setState({
      showMobileMenu: false,
    });
  };

  openOnboarding = () => {
    const hash = window.location.hash;
    if (!hash) {
      window.location.hash = 'onboarding';
    }
    this.closeMobileMenu();
    this.setState({
      showOnboarding: true,
    });
  };
  closeOnboarding = () => {
    window.location.hash = '';
    const isOnboardingShowed = cookies.get('isOnboardingShowed');
    if (!isOnboardingShowed) {
      cookies.set('isOnboardingShowed', true);
    }
    this.setState({
      showOnboarding: false,
    });
  };

  render() {
    const { className, user, router } = this.props;
    const { showMobileMenu, showOnboarding, onboardingTab } = this.state;
    const { route } = router;

    const isUser = user && user.name && !user.code;

    const classMobileMenu = cn({
      'Header__mobile-menu': true,
      'Header__mobile-menu_opened': showMobileMenu,
    });

    return (
      <header className={cn('Header', className)}>
        {showOnboarding && <Onboarding onClose={this.closeOnboarding} tab={onboardingTab} />}

        <div className="Header__content">
          <nav className="Header__controls Header__controls_left">
            <AppLink className="Header__logo" href={`/`} />
            <AppLink className="Header__link Header__link_feed" href={`/`}>
              <span className="Header__link-text">Публикации</span>
            </AppLink>
            <AppLink
              className="Header__link Header__link_about"
              onClick={this.openOnboarding}
              href={`#onboarding`}>
              <span className="Header__link-text">О проекте</span>
            </AppLink>
            <AppLink className="Header__link Header__link_faq" href={`/faq`}>
              <span className="Header__link-text">FAQ</span>
            </AppLink>
          </nav>

          <div className="Header__controls Header__controls_right">
            <div className="Header__hamburger" onClick={this.openMobileMenu} />
          </div>
        </div>

        <div className={classMobileMenu}>
          <div className="Header__mobile-menu-header">
            <div className="Header__mobile-menu-container">
              <AppLink
                className="Header__mobile-menu-logo"
                href={`/`}
                onClick={this.closeMobileMenu}
              />
              <div className="Header__mobile-menu-close" onClick={this.closeMobileMenu} />
            </div>
          </div>
          <nav className="Header__mobile-menu-content">
            <AppLink
              className="Header__link Header__link_feed Header__mobile-link"
              href={`/`}
              onClick={this.closeMobileMenu}>
              Публикации
            </AppLink>

            <AppLink
              className="Header__link Header__link_about Header__mobile-link"
              href={`#onboarding`}
              onClick={this.openOnboarding}>
              О проекте
            </AppLink>

            <AppLink
              className="Header__link Header__link_faq Header__mobile-link"
              href={`/faq`}
              onClick={this.closeMobileMenu}>
              FAQ
            </AppLink>
          </nav>
        </div>
      </header>
    );
  }
}

const User = ({ avatar, name, position }) => {
  const avatarSrc = avatar && avatar != 'null' ? avatar : '/static/images/icons/avatar.svg';
  return (
    <div className="Header__user">
      <div className="Header__avatar">
        <img className="Header__avatar-img" src={avatarSrc} />
      </div>
      <div className="Header__user-info">
        <div className="Header__user-name">{name}</div>
        <div className="Header__user-position">{position}</div>
      </div>
    </div>
  );
};

Header.defaultProps = {
  className: '',
  user: null,
};

Header.propTypes = {
  className: PropTypes.string,
  user: PropTypes.object,
};

export default Header;



// WEBPACK FOOTER //
// components/Header/index.js